import { odataFetch } from "@/lib/odata-fetch";
import { QvEXDSSnagAndNote, qvEXDSSnagAndNote } from "@/odata/appu4dm/QAppU4DM";
import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useQuery } from "@tanstack/react-query";
import { useWorkOrderOperationId } from "../work-order/use-work-order-operation-id";
import { noteKeys } from "./note-keys";
import { vEXDSSnagAndNote } from "@/odata/appu4dm/AppU4DMModel";

export function useNote() {
  const { workOrderOperationId } = useWorkOrderOperationId();
  const wooId = workOrderOperationId?.WorkOrderOperation_Id;

  const { data, ...query } = useQuery({
    queryKey: noteKeys.get(wooId),
    queryFn: ({ meta }) => fetchNotes(wooId!, meta!.token!),
    enabled: ({ meta }) => !!(wooId && meta?.token),
  });

  const isEmpty = query.isSuccess && !data?.value?.[0];

  return {
    notes: data?.value,
    isEmpty,
    ...query,
  };
}

async function fetchNotes(workOrderOperationId: string, token: string) {
  const builder = createQueryBuilderV4(
    "vEXDSSnagAndNote",
    new QvEXDSSnagAndNote()
  ).filter(qvEXDSSnagAndNote.WorkOrderOperation.equals(workOrderOperationId));

  return odataFetch<vEXDSSnagAndNote>({ builder, token });
}
